/* eslint-disable no-console */
import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import update from 'immutability-helper'

import Icon from 'Pods/Shared/Icon/Icon'
import InputField from 'Pods/Shared/InputField'
import GetFileTypeRenderers from 'Utils/GetFileTypeRenderers'

import FileRow from 'Pods/Profile/Products/ArchiveSection/FileRow'
import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'

class FilesListItem extends React.Component {
  constructor(props) {
    super(props)

    const fileInfo = props.file.itemFileInfos.length === 0 ? null : props.file.itemFileInfos[0].attributes
    const fileTypeId = fileInfo && fileInfo.fileTypeId

    this.state = {
      extension: `.${props.file.name.split('.').pop().toLowerCase()}`,
      renderersList: GetFileTypeRenderers(props.fileTypes, fileTypeId),
      nativeFormat: fileInfo && fileInfo.nativeFormat ? fileInfo.nativeFormat : false,
      fileTypeId,
      version: fileInfo && fileInfo.version ? fileInfo.version : '',
      rendererId: fileInfo && fileInfo.rendererId,
      rendererVersion: fileInfo && fileInfo.rendererVersion ? fileInfo.rendererVersion : '',
    }

    this.getFileTypeInfo = this.getFileTypeInfo.bind(this)
    this.canBeNative = this.canBeNative.bind(this)
    this.onNativeTrigger = this.onNativeTrigger.bind(this)
    this.onAttributeUpdate = this.onAttributeUpdate.bind(this)
  }

  getFileTypeInfo() {
    return this.props.fileTypes.find(fileType => fileType.extensions.includes(this.state.extension))
  }

  canBeNative() {
    const fileTypeInfo = this.getFileTypeInfo()

    return fileTypeInfo ? fileTypeInfo.canBeNative : false
  }

  onNativeTrigger() {
    this.setState(prevState => ({ nativeFormat: !prevState.nativeFormat }))

    this.props.onFileNativeTrigger(this.props.file.id, this.props.file.itemFileInfos[0].id, this.state.fileTypeId, !this.state.nativeFormat)
  }

  onAttributeUpdate(attribute, value) {
    const newState = update(this.state, { [attribute]: { $set: value } })

    if (attribute === 'fileTypeId') {
      newState.renderersList = this.props.fileTypes.find(fileType => fileType.id === value).renderers
    }

    this.setState(newState)

    this.props.updateFileAttribute(this.props.file.id, this.props.file.itemFileInfos[0].id, attribute, value)
  }

  render() {
    const filenameClassName = this.props.file.processed === false
      ? 'file-row__filename-text file-row__filename-text--incomplete'
      : 'file-row__filename-text'

    return (
      <FileRow id={this.props.file.id} key={this.props.file.id}>
        {this.canBeNative() && (
          <div className="file-row__col file-row__col--native is-native-visible">
            <input
              id={`file-row-${this.props.file.id}`}
              className="checkbox"
              type="checkbox"
              checked={this.state.nativeFormat}
              onChange={this.onNativeTrigger}
              disabled={this.props.nativeCheckDisabled}
            />
            <label htmlFor={`file-row-${this.props.file.id}`}>Native</label>
          </div>
        )}

        <div className="file-row__col file-row__filename">
          <span className={filenameClassName}>{this.props.file.name}</span>
          {this.props.file.autoGenerated && (
            <Tooltip
              id={`auto-generated-file-${this.props.file.id}`}
              content="This version was generated by CGTrader to meet marketplace standards. Your original upload is preserved."
            >
              <Icon className="file-row__filename-tooltip" type={['fas', 'info-circle']} color="green" />
            </Tooltip>
          )}
          {this.props.file.processed === false && (
            <Tooltip
              id={`incomplete-file-${this.props.file.id}`}
              content={window.I18n.t('profile.model_uploader.file_not_finalized_tooltip')}
            >
              <span className="file-row__status-icon">
                <Icon type={['fas', 'times-circle']} color="red" />
                <span className="sr-only">{window.I18n.t('profile.model_uploader.file_not_finalized_sr')}</span>
              </span>
            </Tooltip>
          )}
        </div>

        {this.props.file.itemFileInfos.length !== 0 && (
          <div className={`file-row__col ${this.state.renderersList.length > 0 ? 'file-row__col--break' : ''}`}>
            <div className="file-row__info-section">
              {this.props.fileTypesForSelect.length > 0 && (
                <Select
                  className="Select-outline file-row__select"
                  options={this.props.fileTypesForSelect}
                  placeholder="Software"
                  searchable
                  clearable={false}
                  value={this.state.fileTypeId}
                  onChange={(data) => data && data.value && this.onAttributeUpdate('fileTypeId', data.value)}
                />
              )}

              <InputField
                placeholder="Version"
                id={`${this.props.file.id}-version`}
                name="version"
                value={this.state.version}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                onChange={(e) => this.onAttributeUpdate(e.target.name, e.target.value)}
              />
            </div>

            {this.state.renderersList.length > 0 && (
              <div className="file-row__info-section">
                <Select
                  className="Select-outline file-row__select"
                  options={this.state.renderersList.map(renderer => ({ value: renderer.id, label: renderer.title }))}
                  placeholder="Renderer"
                  searchable
                  clearable={false}
                  value={this.state.rendererId}
                  onChange={(data) => this.onAttributeUpdate('rendererId', data.value)}
                />

                <InputField
                  placeholder="Version"
                  id={`${this.props.file.id}-renderer-version`}
                  name="rendererVersion"
                  value={this.state.rendererVersion}
                  formClassName="form-group-grey"
                  inputClassName="form-control-grey"
                  onChange={(e) => this.onAttributeUpdate(e.target.name, e.target.value)}
                />
              </div>
            )}
          </div>
        )}

        <div
          className="file-row__col file-row__col--close"
          onClick={() => this.props.removeFile(this.props.file.id)}
        >
          <Icon type={['fal', 'times']} notSpaced />
        </div>
      </FileRow>
    )
  }
}

FilesListItem.propTypes = {
  file: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    processed: PropTypes.bool,
    autoGenerated: PropTypes.bool,
    itemFileInfos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        attributes: PropTypes.shape({
          fileTypeId: PropTypes.number,
          fileTypeTitle: PropTypes.string,
          nativeFormat: PropTypes.bool,
          rendererTitle: PropTypes.string,
          rendererId: PropTypes.number,
          rendererVersion: PropTypes.string,
          version: PropTypes.string,
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
  fileTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      canBeNative: PropTypes.bool,
      renderers: PropTypes.array.isRequired,
    }).isRequired
  ).isRequired,
  fileTypesForSelect: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  removeFile: PropTypes.func.isRequired,
  updateFileAttribute: PropTypes.func.isRequired,
  onFileNativeTrigger: PropTypes.func.isRequired,
  nativeCheckDisabled: PropTypes.bool.isRequired,
}

FilesListItem.defaultProps = {
  file: {
    autoGenerated: false,
    itemFileInfos: [{
      fileTypeId: 0,
      fileTypeTitle: '',
      nativeFormat: false,
      rendererTitle: '',
      rendererId: 0,
      rendererVersion: '',
      version: '',
    }],
  },
  fileTypes: {
    canBeNative: false,
  },
}

export default FilesListItem
